/**
 * @generated SignedSource<<4882d11cb278e6fe5ffa6b3e49d5761d>>
 * @relayHash abd390855976dcf2f5587262910905c4
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID abd390855976dcf2f5587262910905c4

import { ConcreteRequest } from 'relay-runtime';
export type DummyStartVideoCallInput = {
  id: string;
};
export type useDummyCreateVideoCallMutation$variables = {
  input: DummyStartVideoCallInput;
};
export type useDummyCreateVideoCallMutation$data = {
  readonly dummyStartVideoCall: {
    readonly dummyStartVideoCallOutput: {
      readonly patientToken: string;
      readonly roomSid: string;
      readonly sofiaUserToken: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useDummyCreateVideoCallMutation = {
  response: useDummyCreateVideoCallMutation$data;
  variables: useDummyCreateVideoCallMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "DummyStartVideoCallOutput",
  "kind": "LinkedField",
  "name": "dummyStartVideoCallOutput",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roomSid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sofiaUserToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientToken",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDummyCreateVideoCallMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DummyStartVideoCallPayload",
        "kind": "LinkedField",
        "name": "dummyStartVideoCall",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDummyCreateVideoCallMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DummyStartVideoCallPayload",
        "kind": "LinkedField",
        "name": "dummyStartVideoCall",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "abd390855976dcf2f5587262910905c4",
    "metadata": {},
    "name": "useDummyCreateVideoCallMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0111db6069bcc3267ede3192b3c98f01";

export default node;
